<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      v-if="project"
      :class="{
        opened: opened.indexOf('users') >= 0,
        'last-active': opened.indexOf('users') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="$emit('closeBox', 'users')">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
      </div>
      <div class="side-box__title">
        <h2>{{ $t("uzivateleProjektu") }} {{ project.projectName }}</h2>
      </div>
      <div class="side-box__content">
        <div v-if="users.length > 0" class="my-4">
          <div class="d-flex">
            <span class="messages__timestamps__col endpoits gray-text">{{ $t("userId") }}</span>
            <span class="messages__timestamps__col gray-text">{{ $t("email") }}</span>
          </div>
          <div v-for="user in users" :key="user.userId" class="d-flex messages__timestamps__item">
            <span class="messages__timestamps__col endpoits">{{ $t(user.userId) }}</span>
            <span class="messages__timestamps__col">{{ user.email }}</span>
          </div>
        </div>
        <div v-else class="my-4">
          <p>{{ $t("nicKZobrazeni") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import { useCustomerStore } from "@/store/modules/customer"

export default {
  components: {},
  props: {
    project: Object,
    opened: Array
  },
  setup() {
    const customerStore = useCustomerStore()

    return { customerStore }
  },
  data() {
    return {
      users: []
    }
  },
  computed: {
    storedCustomer() {
      return this.customerStore.selectedCustomer
    }
  },
  watch: {},
  mounted() {
    this.loadUsers()
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "users") {
        //this.resetValues();
        this.$emit("closeBox", box)
      } else {
        //this.resetValues();
        this.errors.endpoint = ""
        this.$emit("closeBox", box)
      }
    },
    loadUsers() {
      console.log("loadUsers")
      this.users = []
      axios
        .get(process.env.VUE_APP_API + "/users?limit=1000&customerId[eq]=" + this.storedCustomer.customerId)
        .then((result) => {
          this.users = result.data.data.filter((user) => {
            console.log("user")
            console.log(user)
            console.log("this.project")
            console.log(this.project)
            let users = user.privileges.some(
              (privilege) =>
                privilege.privilege === "ProjectAdmin" &&
                privilege.projectId === this.project.projectId &&
                privilege.customerId === this.project.customerId &&
                privilege.projectId != "."
            )
            return users
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped></style>
